'use client';

import {
    DEVICE_TYPE,
    TruncateWithShowButton,
    useDeviceType,
    FaqSeo,
} from '@libs/common-next';
import { LayoutContainer } from '@petsmart-ui/sparky';
import { Events, dataLayerPush } from '@libs/analytics';
import { parseFaqRichText, parseRichText } from '../../utils/parseRichText';
import { Observer } from '../../utils/Observer';
import type { SeoBlockProps } from './types';

import './SeoBlock.scss';

const trackingData = {
    event: Events.VIEW_PAGE_SECTION,
    page_section: 'plp content',
};

export default function SeoBlock({ content, faq }: Readonly<SeoBlockProps>) {
    const deviceSize = useDeviceType();

    const truncateLine = () => (deviceSize === DEVICE_TYPE.DESKTOP ? 1 : 2);

    const trackingSeoBox = () => {
        dataLayerPush({
            ...trackingData,
            event: 'click_page_section',
            selection: 'expand arrow',
        });
    };

    const parsedFaq = parseFaqRichText(faq);

    return (
        <LayoutContainer
            className="seo-container seo-block__wrapper"
            data-testid="seo-block"
        >
            <Observer {...trackingData} />
            <TruncateWithShowButton
                truncateLine={truncateLine()}
                buttonWordings={{
                    showMore: 'Read more',
                    showLess: 'Read less',
                }}
                className="seo-block__button"
                handleClick={trackingSeoBox}
            >
                {parseRichText(content)}
            </TruncateWithShowButton>
            {parsedFaq && <FaqSeo id="faq-seo" qaArray={parsedFaq} />}
        </LayoutContainer>
    );
}
